import React from 'react';
import CloudUpload from '@material-ui/icons/CloudUpload';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import { appTheme } from 'components/theme';

const useStyles = makeStyles(() => ({
  uploadIcon: {
    marginRight: appTheme.spacing.unit * 2,
    zIndex: 9
  },
  customLabel: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    outline: 'none',
    cursor: 'pointer'
  },
  customLabelText: {
    margin: 0
  }
}));

export default function CustomLabel({
  onLabelClick,
  label = 'Upload File',
  disabled
}) {
  const classes = useStyles();

  return (
    <>
      <div
        className={classes.customLabel}
        onClick={onLabelClick}
        onKeyDown={onLabelClick}
        role="button"
        tabIndex="0"
      >
        <CloudUpload
          className={classes.uploadIcon}
          color={disabled ? 'disabled' : 'primary'}
        />
        <Typography
          variant="body1"
          gutterBottom
          color={disabled ? 'textSecondary' : 'textPrimary'}
          className={classes.customLabelText}
        >
          {label} (
          <em>
            Drag & Drop or{' '}
            <span className="filepond--label-action"> Browse </span>
          </em>
          )
        </Typography>
      </div>
    </>
  );
}
